import { render, staticRenderFns } from "./InfoLinks.vue?vue&type=template&id=5d3818f6&scoped=true&"
import script from "./InfoLinks.vue?vue&type=script&lang=js&"
export * from "./InfoLinks.vue?vue&type=script&lang=js&"
import style0 from "./InfoLinks.vue?vue&type=style&index=0&id=5d3818f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3818f6",
  null
  
)

export default component.exports